import { useSignTransaction, useWallets } from "@privy-io/react-auth/solana"
import { Buffer } from "buffer"
import { useCallback } from "react"
import { getErrorMessage } from "@/lib/errors"

export function useSolanaSign() {
	const { ready, wallets } = useWallets()
	const { signTransaction: privySignTransaction } = useSignTransaction()

	// The first connected wallet from the Privy embedded wallets list
	const wallet = wallets[0] ?? null

	const signTransaction = useCallback(
		async (txBase64: string): Promise<string> => {
			if (!wallet) {
				throw new Error("No wallet available for signing")
			}

			try {
				const txBytes = new Uint8Array(Buffer.from(txBase64, "base64"))

				const { signedTransaction } = await privySignTransaction({
					transaction: txBytes,
					wallet,
				})

				return Buffer.from(signedTransaction).toString("base64")
			} catch (error: unknown) {
				throw new Error(getErrorMessage(error))
			}
		},
		[wallet, privySignTransaction],
	)

	return {
		signTransaction,
		isReady: ready && !!wallet,
	}
}
